var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "11px",
    viewBox: "0 0 20 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.78
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Validera-konto-Copy-5",
    transform: "translate(-657.000000, -142.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(524.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.639552,12.8694576 C150.263934,12.324995 151.211469,12.3897821 151.755931,13.0141634 C152.300394,13.6385447 152.235607,14.5860799 151.611226,15.1305424 L143.798531,21.9432369 C143.233613,22.435847 142.391776,22.435847 141.826858,21.9432369 L134.014163,15.1305424 C133.389782,14.5860799 133.324995,13.6385447 133.869458,13.0141634 C134.41392,12.3897821 135.361455,12.324995 135.985837,12.8694576 L142.812694,18.8224994 L149.639552,12.8694576 Z",
    id: "up",
    transform: "translate(142.812694, 17.406336) scale(1, -1) translate(-142.812694, -17.406336) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.682bbd085d8f6c86ba29c0b78597e2dd.svg";
export { ForwardRef as ReactComponent };